/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmSubscriptionAddress
 */
export interface ConfirmSubscriptionAddress {
    /**
     * Free-text state/region name. Only expected to be a 2-letter USPS code when country is US.
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    line2?: string | null;
    /**
     * Free-text postal code. Only expected to follow US ZIP code format when country is US.
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    city: string;
    /**
     * ISO 3166-1 alpha-2 country code. Defaults to US when omitted, for backward compatibility with clients that do not send it yet.
     * @type {string}
     * @memberof ConfirmSubscriptionAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the ConfirmSubscriptionAddress interface.
 */
export function instanceOfConfirmSubscriptionAddress(value: object): value is ConfirmSubscriptionAddress {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    return true;
}

export function ConfirmSubscriptionAddressFromJSON(json: any): ConfirmSubscriptionAddress {
    return ConfirmSubscriptionAddressFromJSONTyped(json, false);
}

export function ConfirmSubscriptionAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmSubscriptionAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'state': json['state'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function ConfirmSubscriptionAddressToJSON(json: any): ConfirmSubscriptionAddress {
    return ConfirmSubscriptionAddressToJSONTyped(json, false);
}

export function ConfirmSubscriptionAddressToJSONTyped(value?: ConfirmSubscriptionAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': value['state'],
        'line1': value['line1'],
        'line2': value['line2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

